import { ReportResponseDto } from '@/api/WhisApi/generated';

export const flattenReportPages = (
  pages: Record<number, ReportResponseDto[]>,
): ReportResponseDto[] => {
  return Object.keys(pages)
    .map(Number)
    .sort((a, b) => a - b)
    .flatMap((pageNumber) => pages[pageNumber] ?? []);
};
